import React, {Component} from "react";
import {Col, Divider, Row, Table} from 'antd';
import PropTypes from "prop-types";
import moment from 'moment';

/**
 * @author weishihuai
 * @date 2018/6/28
 * @time 16:06
 * @Description: 查看表单
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const columns = [
            {
                title: '排序',
                key: 'pxh',
                dataIndex: 'pxh',
                width: '60px',
            }, {
                title: '字段分类',
                key: 'ZDFL',
                dataIndex: 'zdfl',
                width: '100px'
            }, {
                title: '字段名称',
                key: 'ZDMC',
                dataIndex: 'zdmc',
                width: '100px'
            },
            {
                title: '字段类型',
                key: 'ZDZT',
                dataIndex: 'zdzt',
                width: '100px',
                render: (text, record) => {
                    return text === '1' ? '读写' : text === '2' ? "只读" : "隐藏";
                }
            },
            {
                title: '是否必填',
                key: 'SFBT',
                dataIndex: 'sfbt',
                width: '100px',
                render: (text, record) => {
                    return text === '1' ? '是' : "否";
                }
            },
            {
                title: '默认值',
                key: 'MRZ',
                dataIndex: 'mrz',
                width: '100px'
            }
        ];

        const {bdzdVOs, bdglVO} = this.props.initFormData;
        const startDate = bdglVO.kssj;
        const endDate = bdglVO.jssj;
        let kssj = startDate ? moment(startDate).format('YYYY-MM-DD HH:mm') : '';
        let jssj = endDate ? moment(endDate).format('YYYY-MM-DD HH:mm') : '';

        return (
            <div>
                <Row style={{marginBottom: '10px', fontSize: '20px'}}><b>表单信息</b></Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>表单标志：</b>{bdglVO.bdbz}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>表单名称：</b>{bdglVO.bdmc}</Col>
                </Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>表单采集提示：</b>{bdglVO.bdcjts}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>采集开始时间：</b>{kssj}</Col>
                </Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>采集结束时间：</b>{jssj}</Col>
                    <Col span={12} style={{textAlign: 'left'}}><b>未开始采集提示：</b>{bdglVO.wkscjts}</Col>
                </Row>
                <Row style={{fontSize: '14px', lineHeight: 1.5, marginBottom: '10px'}}>
                    <Col span={12} style={{textAlign: 'left'}}><b>状态：</b>{bdglVO.zt === '1' ? "启用" : "停用"}</Col>
                </Row>
                <Divider/>
                <Row style={{marginBottom: '10px', fontSize: '20px'}}><b>表单字段</b></Row>
                <Table dataSource={bdzdVOs} columns={columns} pagination={false}/>
            </div>
        )
    }
}

ViewForm.propTypes = {
    initFormData: PropTypes.object, //初始数据
};

export default ViewForm;


// WEBPACK FOOTER //
// ./components/xxcj/bdgl/ViewForm.js